class Sharpener2025Thumbnails extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
    this.resizeTimer = null;
    this.handleResize = this.onResize.bind(this);
  }

  connectedCallback() {
    if (this.initialized) return;
    requestAnimationFrame(() => this.init());
    window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
  }

  init() {
    this.thumbsContainer = this.querySelector(".thumbs");
    this.prevButton = this.querySelector(".thumbs-nav--prev");
    this.nextButton = this.querySelector(".thumbs-nav--next");
    this.currentIndex = 0;
    this.visibleThumbs = 7.5; // Show 6 full thumbnails plus half of 7th
    this.thumbWidth = 110;

    if (this.thumbsContainer && this.prevButton && this.nextButton) {
      this.checkSingleImage();
      this.setupThumbnailNavigation();
      this.initialized = true;
    } else {
      console.error('Required elements not found');
    }
  }

  onResize() {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => {
    }, 200);
  }

  checkSingleImage() {
    const thumbnails = this.querySelectorAll('.thumb');
    
    if (thumbnails.length <= 1) {
      if (this.prevButton) this.prevButton.style.display = 'none';
      if (this.nextButton) this.nextButton.style.display = 'none';

      const thumbsContainer = this.querySelector('.thumbs-container');
      if (thumbsContainer) thumbsContainer.style.display = 'none';
    }
  }

  setupThumbnailNavigation() {
    // Add click event listeners for navigation buttons
    this.prevButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.scrollThumbs('prev');
      this.handlePrevSlide()
    });

    this.nextButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.scrollThumbs('next');
      this.handleNextSlide()
    });

    // Add scroll event listener to update navigation buttons
    this.thumbsContainer.addEventListener('scroll', () => {
    });

    this.querySelectorAll('.thumb').forEach((thumb, index) => {
      if (index === 0 && !thumb.classList.contains('active')) {
        thumb.classList.add('active');
      }

      thumb.addEventListener('click', (e) => {
        e.preventDefault();
        const mediaId = thumb.dataset.mediaId;
        this.showMainImage(mediaId);
      });
    });
  }

  handleNextSlide() {
    const currentThumb = this.thumbsContainer.querySelector('.thumb.active');
    const nextThumb = currentThumb.nextElementSibling;
    if (nextThumb) {
      nextThumb.click()
    } else {
      this.thumbsContainer.querySelector('.thumb').click()
    }
  }

  handlePrevSlide() {
    const currentThumb = this.thumbsContainer.querySelector('.thumb.active');
    const prevThumb = currentThumb.previousElementSibling;
    if (prevThumb) {
      prevThumb.click()
    } else {
      const lastThumb = this.thumbsContainer.querySelector('.thumb:last-child');
      if (lastThumb) {
        lastThumb.click()
      }
    }
  }

  scrollThumbs(direction) {
    const scrollAmount = this.thumbWidth;
    
    if (direction === 'prev') {
      this.thumbsContainer.scrollLeft -= scrollAmount;
    } else {
      this.thumbsContainer.scrollLeft += scrollAmount;
    }
  }

  ensureThumbnailVisible(thumbElement) {
    if (!thumbElement) return;
    
    const containerRect = this.thumbsContainer.getBoundingClientRect();
    const thumbRect = thumbElement.getBoundingClientRect();
    
    // Check if thumbnail is outside the visible area
    if (thumbRect.left < containerRect.left) {
      // Thumbnail is to the left, scroll to show it
      this.thumbsContainer.scrollLeft -= (containerRect.left - thumbRect.left);
    } else if (thumbRect.right > containerRect.right) {
      // Thumbnail is to the right, scroll to show it
      this.thumbsContainer.scrollLeft += (thumbRect.right - containerRect.right);
    }
  }

  showMainImage(mediaId) {
    // Remove active class from all thumbnails
    this.querySelectorAll('.thumb').forEach(thumb => {
      thumb.classList.remove('active');
    });
    
    // Add active class to selected thumbnail
    const selectedThumb = this.querySelector(`[data-media-id="${mediaId}"]`);
    if (selectedThumb) {
      selectedThumb.classList.add('active');
      this.ensureThumbnailVisible(selectedThumb);
    }
  }
}

// Register the custom element
customElements.define('sharpener-2025-thumbnails', Sharpener2025Thumbnails);